import { React, useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "../../api/axiosService";
import FadeInSection from "../../Components/FadeInSection";

function Merchandise() {
  const { t } = useTranslation();
  const [merchandiseInfo, setMerchandiseInfo] = useState({
    main_products: [{}],
    products: [{}],
  });
  const [currentIndexMainProduct, setCurrentIndexMainProduct] = useState(0);
  const [link_shop, setLinkShop] = useState("");

  // const link_shop = 'https://shopee.vn/'

  const nextSlide = () => {
    setCurrentIndexMainProduct(
      (prevIndex) => (prevIndex + 1) % merchandiseInfo.main_products.length
    );
  };

  const prevSlide = () => {
    setCurrentIndexMainProduct((prevIndex) =>
      prevIndex === 0 ? merchandiseInfo.main_products.length - 1 : prevIndex - 1
    );
  };

  const getMerchandise = async () => {
    try {
      const response = await axios.get("/api/merchandise/list");
      const mainProducts = response.data.data.filter(
        (product) => product.isFeature
      );
      const products = response.data.data.filter(
        (product) => !product.isFeature
      );
      setMerchandiseInfo({ main_products: mainProducts, products: products });
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  const getLinkShoppe = async () => {
    try {
      const response = await axios.get("/api/setting/info");
      setLinkShop(response.data.data.shoppe_link);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getMerchandise();
    getLinkShoppe();
  }, []);

  const goToShop = () => {
    window.open(link_shop, "_blank");
  };
  return (
    <div className="merchandise-container">
      {/* Header section với animation fade-in từ trên xuống */}
      <FadeInSection direction="down">
        <div className="merchandise-header global-header-block-1">
          <h1 className="merchandise-title title-1">
            {t("merchandise.title")}
          </h1>
          <div className="buy-btn-container global-title-margin">
            <button onClick={goToShop} className="buy-btn normal-text">
              {t("merchandise.buy_now")}
            </button>
          </div>
        </div>
      </FadeInSection>

      {/* Slider với animation fade-in */}
      <FadeInSection delay={200}>
        <div className="slider-wrapper">
          <div
            className="slider-track"
            style={{
              transform: `translateX(-${currentIndexMainProduct * 100}%)`,
            }}
          >
            {merchandiseInfo.main_products.map((product, index) => (
              <a
                key={index}
                href={product.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="slide"
              >
                <img
                  src={product.image}
                  alt={product.productName || `Slide ${index}`}
                  className="image-slider"
                />
              </a>
            ))}
          </div>
          <button onClick={prevSlide} className="previous-btn">
            <FaChevronLeft size={30} />
          </button>
          <button onClick={nextSlide} className="next-btn">
            <FaChevronRight size={30} />
          </button>
        </div>
      </FadeInSection>

      {/* Products Grid với từng sản phẩm có animation fade-in */}
      <div className="product-grid">
        {merchandiseInfo.products.map((product, index) => (
          <FadeInSection key={product.id || index} delay={100 * (index % 3)}>
            <a
              href={product.url}
              target="_blank"
              rel="noopener noreferrer"
              className="product-card"
            >
              <img
                src={product.image}
                alt={`Sản phẩm ${product.id || index}`}
              />
            </a>
          </FadeInSection>
        ))}
      </div>
    </div>
  );
}

export default Merchandise;
